
  document.addEventListener('DOMContentLoaded', function () {
    const desc = document.querySelector('.collection-hero__description.rte');

    if (!desc) return;

    const originalHeight = desc.scrollHeight;
    const maxHeight = parseFloat(getComputedStyle(desc).maxHeight);

    // Only add toggle if content exceeds max height
    if (originalHeight > maxHeight) {
      const toggle = document.createElement('span');
      toggle.className = 'read-more-toggle';
      toggle.textContent = 'Read more';
      desc.after(toggle);

      let expanded = false;

      toggle.addEventListener('click', function () {
        expanded = !expanded;
        if (expanded) {
          desc.classList.add('expanded');
          toggle.textContent = 'Show less';
          desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          desc.classList.remove('expanded');
          toggle.textContent = 'Read more';
          desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  });
